<template>
    <div class="game-feature t-a-c">
        <img :src="info.titlePic" class="d-i-b title-pic" alt="">
        <div class="banner-wrap m-0-a p-r">
            <img :src="info.bannerBg" class="p-a banner-bg" alt="">
            <swipe :id="1" :info="info.swipeInfo"></swipe>
        </div>
    </div>
</template>

<script>
    import swipe from '@components/common/swipe/index'
    export default {
        components: {
            swipe
        },
        props: ['info']
    }
</script>

<style lang="less">
    .game-feature {
        margin-bottom: .933333rem;
        .title-pic {
            width: 6.666667rem;
            height: .826667rem;
            margin-bottom: .346667rem;
        }
    }
    .banner-wrap {
        width: 6.213333rem;
        // height: 9.12rem;
        .banner-bg {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 1;
        }
        .swip-wrap {
            width: 6.213333rem;
            // height: 9.12rem;
        }
        .swipe-btn-prev,
        .swipe-btn-next {
            top: 40%;
            width: .453333rem;
            height: 1.253333rem;
            z-index: 1;
        }
        .swipe-btn-prev {
            left: -1.333333rem;
        }
        .swipe-btn-next {
            right: -1.333333rem;
        }
        .dot {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// client/smsgz/components/index/game-feature.vue